import { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export const CustomViewModal = ({ closeModal, data, header }) => {
  const [keys, setKeys] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    let temp = Object?.keys(data);
    let temp1 = Object?.values(data);
    setKeys(temp);
    setValues(temp1);
  }, [data]);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        height: "100%",
      }}
    >
      <div style={{ width: "100%", position: "relative", paddingBottom: 10 }}>
        <p
          style={{
            color: "black",
            fontSize: "16px",
            textAlign: "center",
          }}
        >
          {header?.length > 0 ? header : "Transaction Details"}
        </p>

        <div
          style={{
            backgroundColor: "#E5E5E5",
            width: "36px",
            height: "36px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            borderRadius: "8px",
            cursor: "pointer",
            top: 0,
          }}
          onClick={() => {
            closeModal();
          }}
        >
          <FaChevronRight size={15} color="#38369C" />
        </div>
      </div>

      {keys &&
        keys?.map((item, index) => {
          return (
            <div key={index}>
              {!Array?.isArray(values[index]) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "20px",
                    paddingRight: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <span
                      style={{ color: "black", minWidth: 220, fontSize: 16 }}
                    >
                      {" "}
                      {Array?.isArray(values[index]) ? "" : keys[index]}
                    </span>
                  </div>
                  <div
                    style={{
                      flexWrap: "wrap",
                      wordBreak: "break-all",
                    }}
                  >
                    <span
                      style={{
                        marginLeft: 0,
                        minWidth: 200,
                        color: "black",
                        fontSize: "16px",
                      }}
                    >
                      {Array?.isArray(values[index]) ? "" : values[index]}
                    </span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};
